import { trpc } from '../../lib/trpc';
import { CheckInHistoryList } from '../checkIns/CheckInHistoryList';

export const CheckInsTab = () => {
  const { data, isLoading, error } = trpc.checkIn.mine.useQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-700" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-error">Failed to load your check-ins. Please try again.</p>
      </div>
    );
  }

  const venues = data?.venues ?? [];

  if (venues.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-sm text-gray-500">
          No check-ins yet. Check in from the mobile app when you visit a winery.
        </p>
      </div>
    );
  }

  return (
    <section>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Wineries visited ({venues.length})
      </h3>
      <CheckInHistoryList items={venues} showDates />
    </section>
  );
};
